import Glide from "@glidejs/glide";

(($) => {
  $(document).ready(function () {
    const $glideEl = $(".references__glide");
    if (!$glideEl.length) return;

    const mq = window.matchMedia("(max-width: 1023px)");
    let glideInstance = null;

    const mountGlide = () => {
      if (glideInstance) return;
      glideInstance = new Glide($glideEl[0], {
        type: "carousel",
        perView: 1,
        gap: 10,
        peek: { before: 15, after: 30 },
        focusAt: "center",
        breakpoints: {
          768: { perView: 1, gap: 10, peek: { before: 15, after: 30 } },
        },
      }).mount();
    };

    const destroyGlide = () => {
      if (glideInstance) {
        glideInstance.destroy();
        glideInstance = null;
      }
    };

    // Initial state
    if (mq.matches) {
      mountGlide();
    }

    // Watch breakpoint changes
    mq.addEventListener("change", (e) => {
      if (e.matches) {
        mountGlide();
      } else {
        destroyGlide();
      }
    });
  });
})(jQuery);
